const parseImageMap = (value) => {
  if (!value) return {}
  if (typeof value === 'object') return value

  try {
    const parsed = JSON.parse(value)
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch (error) {
    return {}
  }
}

export const articleOriginalImages = (article) => parseImageMap(article?.image)

export const articleImageVariants = (article) => parseImageMap(article?.image_variants)

export const articleImages = (article, variant = 'card') => {
  const originals = articleOriginalImages(article)
  const variants = articleImageVariants(article)

  return Object.fromEntries(Object.entries(originals).map(([key, original]) => {
    const available = variants?.[key]
    const url = available?.[variant] || available?.detail || available?.card || available?.thumbnail || original
    return [key, url]
  }))
}

export const articleImage = (article, key = 'image0', variant = 'card') => {
  const images = articleImages(article, variant)
  return images[key] || Object.values(images)[0] || ''
}
